const validate = ({ date = '' }) => {
  const errors = {};

  if (!date) {
    errors.date = 'Debe ingresar una fecha';
  }

  return errors;
};

export default validate;
